import { render, staticRenderFns } from "./setMealForm.vue?vue&type=template&id=3265faf8&scoped=true&"
import script from "./setMealForm.vue?vue&type=script&lang=js&"
export * from "./setMealForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3265faf8",
  null
  
)

export default component.exports